(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class BundlePicker extends HTMLElement {
      constructor() {
        super();

        this.isPreselectVariant = false;
        this.preselectVariants = '';
        this.configScript = null;
        this.bundleConfig = [];
        this.colorConfig = [];
        this.optionMap = null;
        this.productId = '';

        this.boundHandleChange = this.handleChange.bind(this);
      }

      connectedCallback() {
        this.isPreselectVariant = this.dataset.isPreselectVariant === 'true';
        if (this.isPreselectVariant === true) {
          this.preselectVariants = this.dataset.preselectVariants.split(',');
        }
        this.configScript = this.querySelector('script[data-variant]');
        this.configColorScript = this.querySelector('script[data-color]');
        if (!this.configScript) return;

        this.bundleConfig = this.parseConfig(this.configScript);
        this.colorConfig = this.parseConfig(this.configColorScript);
        this.colorMap = new Map(
          this.colorConfig.map((item) => [
            item.name,
            {
              color: item.color,
              label: item.label,
              swatch_1: item.swatch ? item.swatch[String(item.name).toLocaleLowerCase()] : null,
              swatch_2: item.swatch ? item.swatch[String(`${item.name}_2`).toLocaleLowerCase()] : null,
              swatch_3: item.swatch ? item.swatch[String(`${item.name}_3`).toLocaleLowerCase()] : null,
              swatch_4: item.swatch ? item.swatch[String(`${item.name}_4`).toLocaleLowerCase()] : null,
              swatch_5: item.swatch ? item.swatch[String(`${item.name}_5`).toLocaleLowerCase()] : null,
            },
          ])
        );
        this.optionMap = this.buildOptionMap(this.bundleConfig);
        this.productId = this.dataset.productId;

        if (!this.optionMap) return;

        this.render();
        this.bindEvents();
        this.dispatchInitEvent();
      }

      disconnectedCallback() {
        this.unbindEvents();
      }

      render() {
        const container = this.querySelector('.bundle-picker__inner');
        if (!container) {
          console.warn('BundlePicker: .bundle-picker__inner not found');
          return;
        }

        const fragment = document.createDocumentFragment();

        Object.entries(this.optionMap).forEach(([optionName, optionData], index) => {
          const swatchKey = `swatch_${index + 1}`;
          const normalizedOptionName = this.normalizeOptionName(optionName);
          const relatedSelect = document.getElementById(normalizedOptionName);
          const selectedValue = relatedSelect?.value;

          const fieldset = document.createElement('fieldset');
          fieldset.dataset.optionName = optionName;

          const legend = document.createElement('legend');
          const small = document.createElement('small');
          small.textContent = '';
          legend.textContent = `${optionName.replace('_', '')}: `;
          legend.appendChild(small);

          fieldset.appendChild(legend);
          optionData.values.forEach((value, index) => {
            const id = `${normalizedOptionName}-${index}-${this.productId}`;

            const input = document.createElement('input');
            input.type = 'radio';
            input.name = `${normalizedOptionName}-${this.productId}`;
            input.value = value;
            input.id = id;

            if (selectedValue === value) {
              input.checked = true;
            }

            const labelColor = optionData.colors[index] || value;
            const colorInMap = this.colorMap.get(labelColor);
            input.setAttribute('data-label', colorInMap.label || labelColor);
            const label = document.createElement('label');
            label.setAttribute('for', id);
            const span = document.createElement('span');
            const swatch = colorInMap[swatchKey] || colorInMap['swatch_1'];
            if (label && colorInMap && colorInMap.color) {
              span.style.setProperty('--swatch', colorInMap.color);
              label.classList.add('is-swatch');
              if (swatch) {
                span.style.setProperty('--swatch-image', `url(${swatch})`);
                label.classList.add('is-swatch--image');
              }
            }
            span.textContent = optionData.colors[index] || value;
            label.append(span);
            fieldset.append(input, label);
          });

          if (this.isPreselectVariant === true && Array.isArray(this.preselectVariants)) {
            const allInputs = fieldset.querySelectorAll('input');
            const preselectVariant = this.preselectVariants[index];
            const preselectInput = [...allInputs].find((input) =>
              input.value.toLowerCase().includes(preselectVariant.trim())
            );
            if (preselectInput) {
              preselectInput.checked = true;
            }
          } else {
            if (!fieldset.querySelector('input:checked')) {
              const firstInput = fieldset.querySelector('input');
              if (firstInput) firstInput.checked = true;
            }
          }

          fragment.appendChild(fieldset);
        });

        container.appendChild(fragment);
      }

      bindEvents() {
        this.addEventListener('change', this.boundHandleChange.bind(this));
      }

      unbindEvents() {
        this.removeEventListener('change', this.boundHandleChange.bind(this));
      }

      handleChange(event) {
        const input = event.target;
        if (input.type !== 'radio') return;

        const fieldset = input.closest('fieldset');
        if (!fieldset) return;

        const optionName = fieldset.dataset.optionName;
        const normalizedOptionName = this.normalizeOptionName(optionName);

        this.syncSelect(normalizedOptionName, input.value);

        this.dispatchChangeEvent({
          optionName,
          value: input.value,
          inputElement: input,
        });
      }

      syncSelect(optionKey, value) {
        const select = this.offsetParent.querySelector('#' + CSS.escape(optionKey));
        if (!select) return;

        if (select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      dispatchInitEvent() {
        queueMicrotask(() => {
          this.dispatchEvent(
            new CustomEvent('bundle-picker:init', {
              bubbles: true,
              detail: {
                optionMap: this.optionMap,
              },
            })
          );
        });
      }

      dispatchChangeEvent(detail) {
        this.dispatchEvent(
          new CustomEvent('bundle-picker:change', {
            bubbles: true,
            detail: {
              ...detail,
              optionMap: this.optionMap,
            },
          })
        );
      }

      parseConfig(scriptTag) {
        try {
          return JSON.parse(scriptTag.textContent) || [];
        } catch (error) {
          console.error('BundlePicker: Invalid JSON config', error);
          return [];
        }
      }

      buildOptionMap(config = []) {
        if (!Array.isArray(config) || !config.length) return null;

        const optionMap = {};

        config.forEach(({ optionName, optionValues }) => {
          if (!optionName || !optionValues) return;

          const values = String(optionValues)
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean);

          if (values.length < 2) return;

          optionMap[optionName] = { values };
          optionMap[optionName].colors = [];
          values.forEach((value) => {
            const normalizedValue = value
              .split('-')
              .map((element) => element.trim().toLocaleLowerCase())
              .splice(1)
              .join('-');
            optionMap[optionName].colors.push(normalizedValue);
          });
        });

        return optionMap;
      }

      changeLagendText() {
        console.log(this.querySelectorAll('fieldset'));
        this.querySelectorAll('fieldset').forEach((fieldset) => {
          const labelValue = fieldset.querySelector('legend small');
          const checkedInput = fieldset.querySelector('input:checked');
          const {
            dataset: { label },
          } = checkedInput;
          if (label && labelValue) labelValue.textContent = label;
        });
      }

      normalizeOptionName(name = '') {
        return name.trim().toLowerCase().replaceAll(' ', '-');
      }
    }

    if (!customElements.get('bundle-picker')) {
      customElements.define('bundle-picker', BundlePicker);
    }

    const pickers = document.querySelectorAll('.bundle-picker');

    pickers.forEach((picker) => {
      if (!picker) return;

      const updateLegendText = () => {
        picker.changeLagendText?.call(picker);
      };

      const updateBundleSelectionInput = (event) => {
        updateLegendText();

        const root = event?.target?.closest('.main-product-upsells__item') || event?.target?.offsetParent;
        if (!root) return;

        const bundleInput = root.querySelector('.bundle-app-selector input[name="properties[_bundle_selection]"]');
        if (!bundleInput) return;

        const selects = root.querySelectorAll('.bundle-app-selector select');
        const values = [...selects].map((select) => select.value).filter(Boolean);

        bundleInput.value = values.join(' <> ');
      };

      picker.addEventListener('bundle-picker:init', (event) => {
        updateLegendText();
        const { target } = event;
        const upsellItem = target.closest('.main-product-upsells__item');
        const hasBundleContent = !!upsellItem?.querySelector('fieldset');
        if (upsellItem && hasBundleContent) {
          upsellItem?.querySelector('.app-bundle-inputs')?.remove();
        }

        if ('isPreselectVariant' in picker && picker.isPreselectVariant == true) {
          picker
            .querySelectorAll('input:checked')
            .forEach((input) => input.dispatchEvent(new Event('change', { bubbles: true })));
        }
      });
      picker.addEventListener('bundle-picker:change', updateBundleSelectionInput);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
